import { roundTo } from "~/lib/math";

export const computeSalaryRangeBounds = (params: { midpoint: number; width: number }) => {
  return {
    min: roundTo(Math.round(params.midpoint * (1 - params.width)), 100),
    max: roundTo(Math.round(params.midpoint * (1 + params.width)), 100),
  };
};
